import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MapPin, Briefcase, ArrowRight, Building2 } from "lucide-react";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";

const fmtDate = (d) => new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });

export default function Jobs() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/jobs").then((r) => setJobs(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="jobs-page">
      <Seo
        title="Careers"
        path="/jobs"
        description="Join Yayra Glover Organic Inputs and help strengthen Ghana's organic commodity value chain. See current openings and career opportunities in sustainable agriculture."
      />
      <section className="bg-brand text-brand-bg noise-overlay">
        <div className="mx-auto max-w-4xl px-6 py-20 text-center">
          <span className="text-xs uppercase tracking-[0.28em] text-brand-ochre font-semibold">Join Our Team</span>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl">Careers</h1>
          <p className="mt-4 text-brand-bg/80 max-w-xl mx-auto">
            Build a greener future for Ghanaian agriculture. Explore roles across our team.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-6 py-16">
        {loading ? (
          <div className="py-20 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-brand" /></div>
        ) : jobs.length === 0 ? (
          <div className="text-center py-16">
            <Briefcase className="w-10 h-10 text-brand-muted mx-auto" strokeWidth={1.5} />
            <p className="mt-4 text-brand-muted">No open positions right now.</p>
            <p className="text-sm text-brand-muted mt-1">
              We're always keen to meet passionate people — email{" "}
              <a href="mailto:info@yayraglover.com" className="text-brand-terracotta underline">info@yayraglover.com</a>.
            </p>
          </div>
        ) : (
          <div className="space-y-4" data-testid="jobs-list">
            {jobs.map((j) => (
              <Link key={j.job_id} to={`/jobs/${j.slug}`} data-testid={`job-card-${j.slug}`}
                className="group block bg-white border border-brand/10 rounded-sm p-6 hover:shadow-lg hover:border-brand/25 transition-all">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <h2 className="font-display text-xl text-brand group-hover:text-brand-hover transition-colors">{j.title}</h2>
                    <div className="mt-3 flex flex-wrap gap-4 text-sm text-brand-muted">
                      {j.department && <span className="inline-flex items-center gap-1.5"><Building2 className="w-4 h-4" />{j.department}</span>}
                      {j.location && <span className="inline-flex items-center gap-1.5"><MapPin className="w-4 h-4" />{j.location}</span>}
                      <span className="inline-flex items-center gap-1.5"><Briefcase className="w-4 h-4" />{j.employment_type}</span>
                    </div>
                    {j.closes_at && <p className="mt-2 text-xs text-brand-muted">Applications close {fmtDate(j.closes_at)}</p>}
                  </div>
                  <ArrowRight className="w-5 h-5 text-brand-terracotta shrink-0 group-hover:translate-x-1 transition-transform" />
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
